export default __webpack_public_path__ + "static/media/express.613b224e.png";